import React from 'react';
import { motion } from 'framer-motion';
import { Plane, MapPin } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-rich-black pt-20" data-id="element-188">
      {/* Background Elements */}
      <div className="absolute inset-0 z-0" data-id="element-189">
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-rich-black/80 to-rich-black z-10" data-id="element-190" />
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 0.4
      }} transition={{
        duration: 2
      }} className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1436491865332-7a61a109cc05?q=80&w=2074&auto=format&fit=crop')] bg-cover bg-center mix-blend-luminosity" data-id="element-191" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-ocean/30 rounded-full blur-[120px] mix-blend-screen" data-id="element-192" />
        <div className="absolute top-1/4 right-1/4 w-[500px] h-[500px] bg-fuchsia/20 rounded-full blur-[100px] mix-blend-screen" data-id="element-193" />
      </div>

      {/* Floating Elements */}
      <div className="absolute inset-0 z-10 pointer-events-none" data-id="element-194">
        <motion.div className="absolute top-1/4 left-1/4 text-gold/50" animate={{
        y: [0, -20, 0],
        rotate: [0, 10, 0]
      }} transition={{
        duration: 5,
        repeat: Infinity,
        ease: 'easeInOut'
      }} data-id="element-195">
          <Plane size={28} data-id="element-196" />
        </motion.div>
        <motion.div className="absolute top-1/3 right-1/4 text-emerald/40" animate={{
        y: [0, -15, 0],
        rotate: [0, 5, 0]
      }} transition={{
        duration: 4,
        repeat: Infinity,
        ease: 'easeInOut',
        delay: 2
      }} data-id="element-197">
          <MapPin size={20} data-id="element-198" />
        </motion.div>
      </div>

      {/* Content */}
      <div className="relative z-20 container mx-auto px-6 text-center" data-id="element-199">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 0.2
      }} data-id="element-200">
          <span className="inline-block py-1 px-3 rounded-full border border-gold/30 bg-gold/10 text-gold font-sans text-sm tracking-widest uppercase mb-6" data-id="element-201">
            January 27, 2027 • The Global Tour
          </span>
        </motion.div>

        <motion.h1 className="font-display text-5xl md:text-7xl lg:text-8xl font-bold leading-tight mb-6" initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 0.4
      }} data-id="element-202">
          40 Countries <br className="hidden md:block" data-id="element-203" />
          <span className="text-gradient-gold" data-id="element-204">Couldn't Contain Me.</span>
        </motion.h1>

        <motion.p className="font-sans text-lg md:text-xl text-gray-300 max-w-3xl mx-auto mb-12 leading-relaxed" initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 0.6
      }} data-id="element-205">
          For my 40th birthday, I'm celebrating differently. Not one city. Not
          one country. Three unforgettable experiences. Three B's. One global
          celebration.
        </motion.p>

        <motion.div className="flex flex-col sm:flex-row items-center justify-center gap-4" initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 0.8
      }} data-id="element-206">
          <button className="w-full sm:w-auto px-8 py-4 bg-emerald hover:bg-emerald/90 text-white font-sans font-semibold rounded-full transition-all hover:scale-105 hover:shadow-[0_0_20px_rgba(15,81,50,0.5)]" data-id="element-207">
            Find Peace with Me in Bali
          </button>
          <button className="w-full sm:w-auto px-8 py-4 bg-fuchsia hover:bg-fuchsia/90 text-white font-sans font-semibold rounded-full transition-all hover:scale-105 hover:shadow-[0_0_20px_rgba(214,51,108,0.5)]" data-id="element-208">
            Dance With Me Through Brazil
          </button>
          <button className="w-full sm:w-auto px-8 py-4 bg-sunset hover:bg-sunset/90 text-white font-sans font-semibold rounded-full transition-all hover:scale-105 hover:shadow-[0_0_20px_rgba(255,107,53,0.5)]" data-id="element-209">
            Experience the Magic of Botswana
          </button>
        </motion.div>
      </div>
    </section>;
}